import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Icon, Popconfirm, Spin, Table } from 'antd';
import moment from 'moment';

import * as consultantController from '../../../../../../services/api/consultant';

export class TeamList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRowKeys: [],
            dataSource: [],
            isLoading: false
        }
    }

    fetchData() {
        this.setState({ isLoading: true });

        consultantController.getTeams()
            .then((res) => res.json())
            .then((json) => {
                this.setState({ dataSource: json, isLoading: false });
            })
            .catch((err) => console.log(err))
    }

    handleRemove() {
        const { selectedRowKeys } = this.state;
        
        this.setState({ isLoading: true });
        
        consultantController.deleteTeams(selectedRowKeys)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
            })
            .catch((err) => console.log(err))
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        const { isActive } = this.props;

        if (isActive && isActive !== prevProps.isActive)
            this.fetchData();
    }

    renderExpandedTable(record) {
        const columns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        }, {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        }, {
            title: 'Joined at',
            dataIndex: 'joined_at',
            key: 'joined_at',
            align: 'center',
            render: (text) => moment(text).format('YYYY-MM-DD'),
        }];

        if (record.consultants.length !== 0) {
            return (
                <Table
                    size="small"
					rowKey="id"
					columns={columns}
					dataSource={record.consultants}
					pagination={false}
				/>
            )
        } else {
            return (<p style={{ textAlign: 'center' }}>No consultant in this team.</p>)
        }

    }

    render() {
        const { history } = this.props;
        const { selectedRowKeys, dataSource, isLoading } = this.state;
        const isRowSelected = selectedRowKeys.length !== 0;

        const columns = [{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
            width: '60%'
        }, {
            title: 'Created at',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text) => moment(text).format('YYYY-MM-DD'),
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
        }, {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            align: 'center',
            render: (text, record) => (<Icon className="icon-btn" type="edit" onClick={() => history.push(`/dashboard/admin/consultant/team/${record.id}`)} />)
        }];

        return (
            <Spin spinning={isLoading}>
	            <div className="DataList">
	    			<div className="table-btn-gp">
	                    <div className="table-btn-gp-left">
	                        <button onClick={(e) => history.push('/dashboard/admin/consultant/team/new')}>
	                            <Icon type="plus"/>
	                            Create
	                        </button>
	                    </div>
	                    <div className="table-btn-gp-right">
                            <Popconfirm 
                                placement="bottom"
                                title="This action is irreversible, are you sure?" 
                                onConfirm={(e) => this.handleRemove()} 
                                okText="Yes" 
                                cancelText="No"
                            >
                                <button disabled={!isRowSelected}>
                                    <Icon type="minus"/>
                                    Remove
                                </button>
                            </Popconfirm>
	                    </div>
	                </div>
					<Table
                        size="small"
						rowKey="id"
						columns={columns}
						dataSource={dataSource}
						rowSelection={{selectedRowKeys, onChange: (selectedRowKeys) => this.setState({selectedRowKeys})}}
						expandedRowRender={(record) => this.renderExpandedTable(record)}
					/>
				</div>
			</Spin>
        );
    }
}

export default withRouter(TeamList);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ConsultantPage/scenes/TeamList/TeamList.js